
import { defineComponent, onMounted, ref } from "vue";
import { CircleCloseFilled } from "@element-plus/icons";

export default defineComponent({
  name: "guild-0",

  setup(props, { emit }) {
    const drawer = ref(true)
    const step = ref(0)

    const handleClick = (index: number) => {
      step.value = index
    }

    const handleDown = () => {
      window.open('https://www.google.cn/intl/zh-CN/chrome/')
    }

    const handleSkip = () => {
      emit('skip', 1)
    }

    return {
      drawer,
      step,
      handleClick,
      handleDown,
      handleSkip,
      // handleClick,
    };
  },
});
